import React  from 'react';
import { Container, Form, Button, Message, Divider } from 'semantic-ui-react';
import {  getYearsAsStrings, countries, counties, occupations } from '../../../../common/utils/data';
import { withNamespaces } from 'react-i18next';


const FormInput = (props) => {
  return (
    <Form.Input
      width={props.width}
      required
      disabled={props.disabled || false}
      label={props.label}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
    />
  );
};

const ProfileForm = (props) => {
  const { t, data } = props;

  return (
    <Container text>
      <Divider hidden />
      <Form>
        <Form.Group>
          <FormInput
            width={6}
            label={t('common:auth.given_name')}
            name='given_name'
            value={data.given_name}
            onChange={props.onChange}
          />
          <FormInput
            width={6}
            label={t('common:auth.family_name')}
            name='family_name'
            value={data.family_name}
            onChange={props.onChange}
          />
          <Form.Dropdown
            width={4}
            fluid
            search
            selection
            required
            label={t('common:auth.custom.year_of_birth')}
            name='custom:year_of_birth'
            options= {getYearsAsStrings()}
            value={data['custom:year_of_birth']}
            onChange={props.onChange}
          />
        </Form.Group>
        <Form.Group>
          <FormInput
            width={6}
            disabled={true}
            label={t('common:auth.email')}
            name='email'
            value={data.email}
            onChange={props.onChange}
          />
          <FormInput
            width={6}
            label={t('common:auth.custom:phone_number')}
            name='custom:phone_number'
            value={data['custom:phone_number']}
            onChange={props.onChange}
          />
        </Form.Group>
        <Form.Group>
          <Form.Dropdown
            width={6}
            fluid
            selection
            required
            label={t('common:auth.custom:occupation')}
            name='custom:occupation'
            value={data['custom:occupation']}
            options={occupations}
            onChange={props.onChange}
          />
          <FormInput
            width={10}
            label={t('common:auth.custom:occupation_details')}
            name='custom:occupation_details'
            value={data['custom:occupation_details']}
            onChange={props.onChange}
          />
        </Form.Group>
        <Form.Group>
          <Form.Dropdown
            width={6}
            required
            label={t('common:auth.custom:country_of_residence')}
            fluid
            search
            selection
            name='custom:country_of_residence'
            value={data['custom:country_of_residence']}
            options={countries}
            onChange={props.onUpdateCountry}
          />
          {
            data['custom:country_of_residence'] === 'ee' &&
              <Form.Dropdown
                width={10}
                required={data['custom:country_of_residence'] === 'ee'}
                label={t('common:auth.custom:county_of_residence')}
                fluid
                search
                selection
                name='custom:county_of_residence'
                options={counties}
                value={data['custom:county_of_residence']}
                onChange={props.onChange}
              />
          }
        </Form.Group>
        <Divider hidden />
        <div>
          <Button
            disabled={!props.cancelEnabled}
            negative
            content={t('common:cancel')}
            onClick={props.onCancel}/>
          <Button
            disabled={!props.saveEnabled}
            positive
            content={t('common:save')}
            onClick={props.onSave}/>
        </div>
        {
          props.error &&
            <Message negative>
              <Message.Header>{t('common:save_fail')}</Message.Header>
              <p>{t(`common:auth.ex.${props.error}`)}</p>
            </Message>
        }
        {
          props.success &&
            <Message positive>
              <Message.Header>{t('common:save_success')}</Message.Header>
            </Message>
        }
      </Form>
      <Divider hidden />
    </Container>
  );
};

export default withNamespaces('common')(ProfileForm);



// WEBPACK FOOTER //
// ./src/private/user/components/Profile/index.js